export default __webpack_public_path__ + "static/media/mao.4e530c73.svg";